import * as server from '../entries/pages/o-kancelarii/_page.server.ts.js';

export const index = 10;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/o-kancelarii/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/o-kancelarii/+page.server.ts";
export const imports = ["_app/immutable/nodes/10.BjVMlVa8.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DHDEAeFQ.js","_app/immutable/chunks/Dh3qtgeV.js"];
export const stylesheets = [];
export const fonts = [];
